/* CLEVO theme script: offer selector, cart drawer (Shopify AJAX cart API), nav, reveal */
(function () {
  'use strict';

  var C = window.CLEVO || { routes: { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', cartUpdate: '/cart/update' }, moneyFormat: 'R {{amount}}' };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var offers = {}; // productId -> offer data from the page

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    format = format || C.moneyFormat || 'R {{amount}}';
    function delimit(n, precision, thousands, decimal) {
      var parts = (n / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals': value = delimit(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = delimit(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = delimit(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = delimit(cents, 2, "'", '.'); break;
      default: value = delimit(cents, 2, ',', '.');
    }
    // Match Liquid's money_without_trailing_zeros
    value = value.replace(/[.,]00$/, '');
    return format.replace(/\{\{\s*\w+\s*\}\}/, value).replace(/<[^>]*>/g, '');
  }

  function packFromTitle(title, fallback) {
    var first = String(title || '').trim().split(' ')[0];
    var n = /^\d+$/.test(first) ? parseInt(first, 10) : 0;
    return n > 0 ? n : (fallback || 1);
  }
  function itemPack(item) {
    var offer = offers[item.product_id];
    if (offer) {
      var v = offer.variants.filter(function (x) { return x.id === item.variant_id; })[0];
      if (v) return v.pack;
    }
    var opt = (item.options_with_values && item.options_with_values[0]) ? item.options_with_values[0].value : item.variant_title;
    return packFromTitle(opt, 1);
  }
  function setsLabel(offer, n) {
    return n + ' × ' + (n === 1 ? offer.setSingular : offer.setPlural);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  /* ---------- Cart API ---------- */
  function jsonUrl(route) { return route.replace(/\/$/, '') + '.js'; }
  function request(url, body) {
    var opts = body ? { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) } : { headers: { 'Accept': 'application/json' } };
    return fetch(url, opts).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok) {
          var err = new Error(data.description || data.message || 'Something went wrong. Please try again.');
          err.status = res.status;
          throw err;
        }
        return data;
      });
    });
  }
  function getCart() { return request(jsonUrl(C.routes.cart)); }

  /* Put exactly one pack of this product in the cart: the chosen one. */
  function setPack(productId, variantId) {
    return getCart().then(function (cart) {
      var existing = null, updates = {}, replaced = false;
      cart.items.forEach(function (item) {
        if (item.product_id !== productId) return;
        if (item.variant_id === variantId) { existing = item; if (item.quantity !== 1) updates[item.key] = 1; }
        else { updates[item.key] = 0; replaced = true; }
      });
      var chain = Promise.resolve();
      if (Object.keys(updates).length) chain = chain.then(function () { return request(jsonUrl(C.routes.cartUpdate), { updates: updates }); });
      if (!existing) chain = chain.then(function () { return request(jsonUrl(C.routes.cartAdd), { items: [{ id: variantId, quantity: 1 }] }); });
      return chain.then(getCart).then(function (newCart) {
        return { cart: newCart, status: existing && !replaced ? 'same' : (replaced ? 'replaced' : 'added') };
      });
    });
  }

  /* ---------- Offer selector ---------- */
  function initOffer(root) {
    var jsonEl = $('[data-offer-json]', root);
    var form = $('[data-offer-form]', root);
    if (!jsonEl || !form) return;
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    offers[data.productId] = data;

    function variantById(id) { return data.variants.filter(function (v) { return v.id === id; })[0]; }

    function update() {
      var input = $('input[name="id"]:checked', form);
      if (!input) return;
      var v = variantById(Number(input.value));
      if (!v) return;
      $$('.opt', form).forEach(function (l) { l.classList.toggle('is-selected', Number(l.getAttribute('data-variant-id')) === v.id); });
      var saving = v.compare > v.price ? v.compare - v.price : 0;
      $('[data-sum-label]', root).textContent = v.title;
      $('[data-sum-compare]', root).innerHTML = saving ? '<s>' + esc(formatMoney(v.compare)) + '</s>' : '';
      $('[data-sum-save-row]', root).hidden = !saving;
      $('[data-sum-save]', root).textContent = saving ? formatMoney(saving) + ' (' + Math.round(saving * 100 / v.compare) + '%)' : '';
      $('[data-sum-total]', root).textContent = formatMoney(v.price);
      var btn = $('[data-add-btn]', root);
      btn.disabled = !v.available;
      btn.textContent = v.available ? 'Add to cart · ' + formatMoney(v.price) : 'Sold out';
      $$('[data-qty-icons] .qty-icon', root).forEach(function (el) { el.classList.toggle('off', Number(el.getAttribute('data-i')) > v.pack); });
      $('[data-qty-text]', root).innerHTML = '<b>' + v.pack + ' complete ' + (v.pack === 1 ? 'set' : 'sets') + '</b>' +
        (v.pack === 1 ? 'One handle, the extension pole and all 7 heads' : v.pack + ' handles, ' + v.pack + ' extension poles, ' + (v.pack * 7) + ' heads in total');
      $('[data-offer-error]', root).hidden = true;
    }

    form.addEventListener('change', function (e) { if (e.target.name === 'id') update(); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = $('input[name="id"]:checked', form);
      if (!input) return;
      var v = variantById(Number(input.value));
      var btn = $('[data-add-btn]', root);
      var errorEl = $('[data-offer-error]', root);
      btn.classList.add('is-loading');
      setPack(data.productId, v.id).then(function (res) {
        var msg = res.status === 'same' ? v.title + ' is already in your cart'
          : (res.status === 'replaced' ? 'Cart updated to ' : 'Added ') + v.title + ' · ' + formatMoney(v.price);
        toast(msg);
        renderCart(res.cart, true);
        openDrawer(res.cart);
      }).catch(function (err) {
        errorEl.textContent = err.message;
        errorEl.hidden = false;
      }).then(function () { btn.classList.remove('is-loading'); });
    });
    update();
  }

  /* ---------- Refund request: carry the order number into the proof-of-payment email ---------- */
  function initRefund() {
    var KEY = 'clevo-refund-order';
    var order = $('[data-refund-order]');
    if (order && order.form) {
      order.form.addEventListener('submit', function () {
        try { sessionStorage.setItem(KEY, order.value.trim()); } catch (e) {}
      });
    }
    var link = $('[data-proof-link]');
    if (!link) return;
    var num = '';
    try { num = sessionStorage.getItem(KEY) || ''; } catch (e) {}
    var subject = 'Proof of payment' + (num ? ' – Order ' + num : '');
    var body = 'Hi CLEVO,\n\nPlease find my proof of payment attached for my refund request' + (num ? ' (order ' + num + ')' : '') + '.\n\nThanks';
    link.href = 'mailto:' + link.getAttribute('data-email') + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
  }

  /* ---------- Cart drawer ---------- */
  var drawer, scrim, lastFocus;

  function brushCount(cart) {
    return cart.items.reduce(function (sum, item) { return sum + itemPack(item) * item.quantity; }, 0);
  }

  function renderCount(cart, bump) {
    var el = $('#cartCount');
    if (!el) return;
    var n = brushCount(cart);
    el.textContent = n;
    el.hidden = n === 0;
    var btn = $('#cartBtn');
    if (btn) btn.setAttribute('aria-label', 'Open cart, ' + n + ' items');
    if (bump) { el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); }
  }

  function imgUrl(src, w) {
    if (!src) return C.fallbackImage;
    try { var u = new URL(src, window.location.origin); u.searchParams.set('width', w); return u.toString(); } catch (e) { return src; }
  }

  function renderCart(cart, bump) {
    renderCount(cart, bump);
    if (!drawer) return;
    var body = $('[data-cart-body]', drawer), foot = $('[data-cart-foot]', drawer);
    if (!cart.items.length) {
      body.innerHTML = '<div class="empty"><h3>Your cart is empty</h3><p>Choose how many CLEVO brushes you need to get started.</p>' +
        '<a href="' + esc((C.routes.root === '/' ? '' : C.routes.root) + '/#shop') + '" class="btn btn-primary" data-cart-close>Choose your brushes</a></div>';
      foot.innerHTML = '';
      return;
    }
    var html = '';
    cart.items.forEach(function (item) {
      var offer = offers[item.product_id];
      var pack = itemPack(item);
      html += '<div class="line-item" data-line-key="' + esc(item.key) + '">' +
        '<div class="line-thumb"><img src="' + esc(imgUrl(item.image, 200)) + '" alt="" width="76" height="76" loading="lazy"></div>' +
        '<div><div class="line-name">' + esc(item.variant_title && offer ? item.variant_title : item.product_title) + '</div>' +
        '<div class="line-desc">' + esc(offer ? setsLabel(offer, pack) + (item.quantity > 1 ? ' (×' + item.quantity + ')' : '') : (item.variant_title || '') + (item.quantity > 1 ? ' × ' + item.quantity : '')) + '</div>' +
        '<div class="line-meta"><span class="line-price">' + esc(formatMoney(item.final_line_price)) + '</span>' +
        '<button type="button" class="link-btn" data-remove="' + esc(item.key) + '">Remove</button></div></div></div>';
      if (offer && offer.variants.length > 1) {
        html += '<p class="change-label">Change how many brushes</p><div class="chips">' +
          offer.variants.map(function (v) {
            return '<button type="button" class="chip" data-switch-product="' + offer.productId + '" data-switch-variant="' + v.id + '" aria-pressed="' + (v.id === item.variant_id) + '"' + (v.available ? '' : ' disabled') + '>' +
              v.pack + '<small>' + esc(formatMoney(v.price)) + '</small></button>';
          }).join('') + '</div>' +
          '<div class="clarify" style="margin-top:16px">' + infoIcon + '<span>Each brush includes the complete 7-in-1 cleaning set.</span></div>';
      }
    });
    body.innerHTML = html;
    var discount = cart.total_discount || 0;
    var fee = Number(C.shippingFlat) || 0;
    foot.innerHTML =
      '<div class="sum-line"><span>Subtotal (' + brushCount(cart) + ' ' + (brushCount(cart) === 1 ? 'item' : 'items') + ')</span><span>' + esc(formatMoney(cart.items_subtotal_price)) + '</span></div>' +
      (discount ? '<div class="sum-line"><span>Discount</span><span class="sum-save">−' + esc(formatMoney(discount)) + '</span></div>' : '') +
      (fee ? '<div class="sum-line"><span>Delivery' + (C.shippingRegion ? ' (' + esc(C.shippingRegion) + ')' : '') + '</span><span>' + esc(formatMoney(fee)) + '</span></div>'
           : '<div class="sum-line"><span>Shipping</span><span>Calculated at checkout</span></div>') +
      '<div class="sum-line sum-total" style="margin-top:10px"><span>' + (fee ? 'Total incl. delivery' : 'Total') + '</span><b data-cart-total>' + esc(formatMoney(cart.total_price + fee)) + '</b></div>' +
      '<form action="' + esc(C.routes.cart) + '" method="post"><button type="submit" name="checkout" class="btn btn-primary btn-block" style="margin-top:16px" data-checkout>Checkout · ' + esc(formatMoney(cart.total_price + fee)) + '</button></form>' +
      '<p class="drawer-note">' + (fee ? 'One delivery fee per order, however many brushes you choose. Payment options are shown at checkout.' : 'Shipping and payment options are shown at checkout.') + '</p>';
  }
  var infoIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/></svg>';

  function openDrawer(cart) {
    if (!drawer) return;
    lastFocus = document.activeElement;
    var ready = cart ? Promise.resolve(cart) : getCart();
    ready.then(function (c) { renderCart(c); }).catch(function () {
      $('[data-cart-body]', drawer).innerHTML = '<div class="empty"><h3>We couldn\'t load your cart</h3><p>Please refresh the page and try again.</p></div>';
    });
    drawer.classList.add('open'); scrim.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { var b = $('[data-cart-close].icon-btn', drawer); if (b) b.focus(); }, 60);
  }
  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('open')) return;
    drawer.classList.remove('open'); scrim.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function syncOfferSelection(productId, variantId) {
    $$('[data-offer-form]').forEach(function (form) {
      var input = $('input[name="id"][value="' + variantId + '"]', form);
      if (input && !input.checked) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  }

  function initDrawer() {
    drawer = $('#cartDrawer'); scrim = $('#cartScrim');
    if (!drawer) return;
    document.addEventListener('click', function (e) {
      var open = e.target.closest('[data-cart-open]');
      if (open) { e.preventDefault(); openDrawer(); return; }
      if (e.target.closest('[data-cart-close]')) {
        var link = e.target.closest('a[data-cart-close]');
        closeDrawer();
        if (!link) e.preventDefault();
        return;
      }
      var rm = e.target.closest('[data-remove]');
      if (rm) {
        rm.disabled = true;
        request(jsonUrl(C.routes.cartChange), { id: rm.getAttribute('data-remove'), quantity: 0 })
          .then(function (cart) { renderCart(cart, true); toast('Removed from cart'); })
          .catch(function (err) { toast(err.message); rm.disabled = false; });
        return;
      }
      var sw = e.target.closest('[data-switch-variant]');
      if (sw) {
        var pid = Number(sw.getAttribute('data-switch-product')), vid = Number(sw.getAttribute('data-switch-variant'));
        $$('.chip', drawer).forEach(function (c) { c.disabled = true; });
        setPack(pid, vid).then(function (res) {
          renderCart(res.cart, true);
          syncOfferSelection(pid, vid);
          var v = offers[pid].variants.filter(function (x) { return x.id === vid; })[0];
          if (res.status !== 'same') toast('Cart updated to ' + v.title);
        }).catch(function (err) { toast(err.message); getCart().then(function (c) { renderCart(c); }); });
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $('#toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }

  /* ---------- Mobile nav ---------- */
  function initNav() {
    var btn = $('#menuBtn'), links = $('#navLinks');
    if (!btn || !links) return;
    btn.addEventListener('click', function () {
      var open = links.classList.toggle('open');
      btn.setAttribute('aria-expanded', open);
    });
    links.addEventListener('click', function (e) {
      if (e.target.closest('a')) { links.classList.remove('open'); btn.setAttribute('aria-expanded', false); }
    });
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var els = $$('.reveal');
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches || (window.Shopify && window.Shopify.designMode)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function init() {
    $$('[data-offer-root]').forEach(initOffer);
    initDrawer();
    initRefund();
    initNav();
    initReveal();
    // Re-initialise sections when edited in the Shopify theme editor
    document.addEventListener('shopify:section:load', function (e) {
      $$('[data-offer-root]', e.target).forEach(initOffer);
      $$('.reveal', e.target).forEach(function (el) { el.classList.add('in'); });
    });
    // Keep the header count right if the cart changed in another tab
    window.addEventListener('pageshow', function (e) { if (e.persisted) getCart().then(function (c) { renderCount(c); }); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  window.CLEVO = C;
  C.formatMoney = formatMoney;
  C.openCart = openDrawer;
})();
